// SEO Schema.org JSON-LD for the website

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

// Organization Schema
const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Recordatorios WhatsApp Clínicas",
  "url": siteUrl,
  "logo": `${siteUrl}/vite.svg`,
  "description": "Servicio de recordatorios automáticos por WhatsApp para clínicas y negocios con citas. Integración con Google Calendar.",
  "email": "smarttechsolutions30@gmail.com",
  "telephone": "+34679602857",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "ES"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+34679602857",
    "contactType": "customer service",
    "email": "smarttechsolutions30@gmail.com",
    "availableLanguage": "Spanish"
  }
};

// WebSite Schema
const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Recordatorios WhatsApp Clínicas",
  "url": siteUrl,
  "description": "Reduce las citas perdidas con recordatorios automáticos por WhatsApp para clínicas",
  "publisher": {
    "@type": "Organization",
    "name": "Recordatorios WhatsApp Clínicas"
  }
};

// Service Schema
const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Recordatorios Automáticos por WhatsApp",
  "provider": {
    "@type": "Organization",
    "name": "Recordatorios WhatsApp Clínicas"
  },
  "areaServed": {
    "@type": "Country",
    "name": "España"
  },
  "description": "Servicio de recordatorios automáticos por WhatsApp conectando Google Calendar con WhatsApp del paciente para reducir no-shows en clínicas",
  "offers": {
    "@type": "Offer",
    "price": "49",
    "priceCurrency": "EUR",
    "priceSpecification": {
      "@type": "UnitPriceSpecification",
      "price": "49",
      "priceCurrency": "EUR",
      "unitText": "MONTH"
    },
    "availability": "https://schema.org/InStock"
  },
  "audience": {
    "@type": "Audience",
    "audienceType": "Clínicas, fisioterapia, dentistas, podología, centros de estética"
  }
};

// FAQ Schema
const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "¿Cómo funciona el servicio de recordatorios automáticos por WhatsApp?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "El sistema se conecta directamente con tu Google Calendar. Cuando agendas una cita, el sistema detecta automáticamente la información y envía un recordatorio por WhatsApp al paciente antes de la cita programada."
      }
    },
    {
      "@type": "Question",
      "name": "¿Cuánto cuesta el servicio?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "El servicio tiene un precio desde 49€ al mes, sin permanencia. Incluye recordatorios automáticos ilimitados y soporte completo."
      }
    },
    {
      "@type": "Question",
      "name": "¿Puedo probar el servicio antes de contratar?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Sí, ofrecemos una demo gratuita de 5 días sin compromiso para que puedas probar el servicio y ver los resultados en tu clínica."
      }
    },
    {
      "@type": "Question",
      "name": "¿Qué tipos de clínicas pueden usar este servicio?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "El servicio está diseñado para clínicas de fisioterapia, dentistas, podología, centros de estética y cualquier negocio que trabaje con citas programadas."
      }
    }
  ]
};

// BreadcrumbList Schema
const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Inicio",
      "item": siteUrl
    }
  ]
};

// Function to inject schemas into the page
function injectSchemas() {
  const schemas = [
    organizationSchema,
    websiteSchema,
    serviceSchema,
    faqSchema,
    breadcrumbSchema
  ];

  schemas.forEach((schema, index) => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    script.id = `schema-${index}`;
    document.head.appendChild(script);
  });

  // Add canonical link dynamically
  const canonical = document.createElement('link');
  canonical.rel = 'canonical';
  canonical.href = siteUrl;
  document.head.appendChild(canonical);

  // Update Open Graph URL
  let ogUrl = document.querySelector('meta[property="og:url"]');
  if (!ogUrl) {
    ogUrl = document.createElement('meta');
    ogUrl.setAttribute('property', 'og:url');
    document.head.appendChild(ogUrl);
  }
  ogUrl.setAttribute('content', siteUrl);
}

// Execute when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', injectSchemas);
} else {
  injectSchemas();
}

export {};
